import { render, staticRenderFns } from "./PaymentAdditionModal.vue?vue&type=template&id=3b81c582"
import script from "./PaymentAdditionModal.vue?vue&type=script&lang=js"
export * from "./PaymentAdditionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports